import React from 'react'
import { useMemo } from 'sb-hooks'
import { formatPrice } from 'common/helpers'

import Text from 'components/_new/typography/Text/Text'
import { CircleLoader } from 'components/_new/ui'


type PriceProps = {
  id?: string
  className?: string
  children?: number
  value?: number
  loading?: boolean
  isCents?: boolean
  withCents?: boolean
  dataTestId?: string
}

const Price: React.FunctionComponent<PriceProps> = (props) => {
  const {
    children, className, id, value, dataTestId,
    loading = false, isCents = false, withCents = true,
  } = props

  const formattedPrice = useMemo(() => formatPrice(
    children || value,
    isCents,
    true,
    withCents ? 2 : 0
  ), [ children, value, isCents, withCents ])

  return loading ? (
    <CircleLoader />
  ) : (
    <Text
      id={id}
      className={className}
      message={formattedPrice}
      tag="span"
      dataTestId={dataTestId}
      inherit
    />
  )
}


export default Price
